import React from 'react';
import { Heading } from '../Typography/Heading';
import { Text } from '../Typography/Text';
import { Button } from '../Button/Button';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  headline: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  /** Visual variant of the action button. Use 'secondary' when the page header already has the primary action. Defaults to 'primary'. */
  actionVariant?: 'primary' | 'secondary';
  /** Heading level of the headline. Use 4 when the empty state sits inside a card whose title is an h3. Defaults to 2. */
  headingLevel?: 2 | 3 | 4;
  className?: string;
}

export function EmptyState({
  icon,
  headline,
  description,
  actionLabel,
  onAction,
  actionVariant = 'primary',
  headingLevel = 2,
  className,
}: EmptyStateProps) {
  return (
    <div className={[styles.wrapper, className].filter(Boolean).join(' ')} role="status">
      {icon != null && (
        <div className={styles.iconWrapper} aria-hidden="true" data-testid="empty-state-icon">
          {icon}
        </div>
      )}
      <Heading level={headingLevel} className={styles.headline}>{headline}</Heading>
      {description != null && (
        <Text className={styles.description}>{description}</Text>
      )}
      {actionLabel != null && onAction != null && (
        <Button
          variant={actionVariant}
          className={styles.action}
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
